/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum AuditLogEventType {
    Activity = 'Activity',
    AiAgent = 'AiAgent',
    Alarm = 'Alarm',
    AlarmListener = 'AlarmListener',
    Alert = 'Alert',
    Application = 'Application',
    AuthConfig = 'AuthConfig',
    AutomationWorkflows = 'AutomationWorkflows',
    AwsSsm = 'AwsSsm',
    Billing = 'Billing',
    BillingPlans = 'BillingPlans',
    Blueprint = 'Blueprint',
    BlueprintJobs = 'BlueprintJobs',
    Catalog = 'Catalog',
    CloudAccount = 'CloudAccount',
    ComplianceStandard = 'ComplianceStandard',
    CostAnomaly = 'CostAnomaly',
    CostAnomalyDashboard = 'CostAnomalyDashboard',
    CostBudget = 'CostBudget',
    CostBudgetAction = 'CostBudgetAction',
    CostBudgetAlert = 'CostBudgetAlert',
    CostBudgetNotification = 'CostBudgetNotification',
    CostBudgetReview = 'CostBudgetReview',
    CostDashboard = 'CostDashboard',
    CostMarkupDiscount = 'CostMarkupDiscount',
    CostOptimization = 'CostOptimization',
    CostOptimizer = 'CostOptimizer',
    CostPosture = 'CostPosture',
    CurrencyExchangeConfiguration = 'CurrencyExchangeConfiguration',
    CustomTags = 'CustomTags',
    Dimension = 'Dimension',
    GovernanceConfiguration = 'GovernanceConfiguration',
    IntegratedTool = 'IntegratedTool',
    Inventory = 'Inventory',
    InventoryElements = 'InventoryElements',
    KubernetesCluster = 'KubernetesCluster',
    Locks = 'Locks',
    LogAnalyticsWorkspaces = 'LogAnalyticsWorkspaces',
    MasterAccount = 'MasterAccount',
    Policy = 'Policy',
    PolicyRecommendation = 'PolicyRecommendation',
    PolicyParameterConfiguration = 'PolicyParameterConfiguration',
    Portfolio = 'Portfolio',
    Project = 'Project',
    RecommendationExclusionRule = 'RecommendationExclusionRule',
    Report = 'Report',
    Request = 'Request',
    Request_iaas = 'Request-iaas',
    Request_workload = 'Request-workload',
    RequestApproval_iaas = 'RequestApproval-iaas',
    RequestApproval_workload = 'RequestApproval-workload',
    RequestJob = 'RequestJob',
    ResourceCatalog = 'ResourceCatalog',
    RoleAccessPolicies = 'RoleAccessPolicies',
    SaaS = 'SaaS',
    Sbom = 'Sbom',
    Scheduler = 'Scheduler',
    ScriptComponent = 'ScriptComponent',
    ScriptJobs = 'ScriptJobs',
    Scripts = 'Scripts',
    Services = 'Services',
    SwitchMasterAccount = 'SwitchMasterAccount',
    Template = 'Template',
    TemplateBuilder = 'TemplateBuilder',
    TemplateJobs = 'TemplateJobs',
    Tenant = 'Tenant',
    User = 'User',
    UserDelegation = 'UserDelegation',
    UserGroup = 'UserGroup',
    UserInvite = 'UserInvite',
    UserLogin = 'UserLogin',
    WellArchitectedAssessment = 'WellArchitectedAssessment',
    WellArchitectedAssessmentRun = 'WellArchitectedAssessmentRun',
    WellArchitectedCustomFramework = 'WellArchitectedCustomFramework',
    WellArchitectedWorkload = 'WellArchitectedWorkload',
    WorkloadComponent = 'WorkloadComponent'
}
